// extracted by mini-css-extract-plugin
export default {"LocationDetailCont":"LocationDetails_LocationDetailCont__UdZUC","radioBtnsWrapper":"LocationDetails_radioBtnsWrapper__kw5eo"};